import { Link } from 'react-router-dom';

const footerLinks = {
  content: {
    title: '精彩内容',
    items: [
      { label: '最新作品', path: '/category/all' },
      { label: '热门推荐', path: '/category/all' },
      { label: '原创剧集', path: '/category/all' },
      { label: '独家花絮', path: '/category/all' },
    ],
  },
  service: {
    title: '会员服务',
    items: [
      { label: '会员权益', path: '/#membership' },
      { label: '订阅方案', path: '/#membership' },
      { label: '常见问题', path: '/#faq' },
      { label: '用户协议', path: '/' },
    ],
  },
  about: {
    title: '关于我们',
    items: [
      { label: '品牌介绍', path: '/about' },
      { label: '口碑评价', path: '/about' },
      { label: '联系我们', path: '/about' },
      { label: '加入我们', path: '/about' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <span className="text-xl font-heading font-bold text-white">麻豆传媒</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed max-w-xs">
              专注优质影视内容制作与发行的专业传媒机构，提供正版高清影视资源、原创剧情内容及多元娱乐体验。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-white transition-all duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-white transition-all duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-white transition-all duration-200 cursor-pointer" aria-label="Bilibili">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-white transition-all duration-200 cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
            </div>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-white mb-4">{section.title}</h4>
              <ul className="flex flex-col gap-3">
                {section.items.map((item) => (
                  <li key={item.label}>
                    <Link
                      to={item.path}
                      className="text-sm text-background-400 hover:text-white transition-colors duration-200 cursor-pointer"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 麻豆传媒版权所有 | 保留所有权利
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer">Cookie 政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}